import CompanyInfo from 'State/Interfaces/CompanyInfo';
const CompanyState: CompanyInfo = {
	_id: '',
    businessName: '',
    category: ''
};

export default CompanyState;